'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  float: left;\n  color: white;\n  font-size: 0.5rem;\n  margin-left: 1em;\n\n  a, a:hover, a:active, a:visited {\n    color: white;\n    cursor: pointer;\n    height: 42px;\n    width: 84px;\n\n    img {\n      src: ', '\n      height: 2rem;\n      margin-top: 0.5rem;\n    }\n  }\n'], ['\n  display: inline-block;\n  float: left;\n  color: white;\n  font-size: 0.5rem;\n  margin-left: 1em;\n\n  a, a:hover, a:active, a:visited {\n    color: white;\n    cursor: pointer;\n    height: 42px;\n    width: 84px;\n\n    img {\n      src: ', '\n      height: 2rem;\n      margin-top: 0.5rem;\n    }\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Brand = _styledComponents2.default.div(_templateObject, function (props) {
  return props.icon;
});

exports.default = Brand;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/navigation/brand.js
// module id = 690
// module chunks = 0